// Define the specific columns we want to show
export const DESIRED_COLUMNS = [
  'sr_no',
  'masterlist_alias', 
  'alias',
  'image_alias',
  'monument_alias',
  'monument_name'
];

// RJSF Schema for the edit form
export const EDIT_SCHEMA = {
  title: "Edit Man-Made Heritage Record",
  type: "object",
  properties: {
    sr_no: {
      type: "number",
      title: "Serial Number"
    },
    masterlist_alias: {
      type: "string",
      title: "Masterlist Alias"
    },
    monument_name: {
      type: "string",
      title: "Monument Name"
    },
    monument_alias: {
      type: "string",
      title: "Monument Alias"
    },
    alias: {
      type: "string",
      title: "Alias"
    },
    sortable_year: {
      type: "number",
      title: "Sortable Year"
    },
    image_alias: {
      type: "string",
      title: "Image Alias"
    },
    bibliographic_citation: {
      type: "string",
      title: "Bibliographic Citation",
      readOnly: true
    },
    preface: {
      type: "string",
      title: "Preface"
    },
    patron: {
      type: "string",
      title: "Patron"
    },
    background: {
      type: "string",
      title: "Background"
    },
    structure: {
      type: "string",
      title: "Structure"
    },
    layout: {
      type: "string",
      title: "Layout"
    },
    materials_used: {
      type: "string",
      title: "Materials Used"
    },
    event: {
      type: "string",
      title: "Event"
    },
    location: {
      type: "string",
      title: "Location"
    },
    status: {
      type: "string",
      title: "Status"
    },
    architectural_style: {
      type: "string",
      title: "Architectural Style"
    },
    heritage_type: {
      type: "string",
      title: "Heritage Type"
    }
  }
};

// UI Schema for the edit form
export const EDIT_UI_SCHEMA = {
  sr_no: {
    "ui:readonly": true
  },
  masterlist_alias: {
    "ui:readonly": true
  },
  alias: {
    "ui:readonly": true
  },
  preface: {
    "ui:options": {
      placeholder: "Enter preface content...",
      height: "300px"
    }
  },
  patron: {
    "ui:options": {
      placeholder: "Enter patron information...",
      height: "300px"
    }
  },
  background: {
    "ui:options": {
      placeholder: "Enter background information...",
      height: "300px"
    }
  },
  structure: {
    "ui:options": {
      placeholder: "Enter structure details...",
      height: "300px"
    }
  },
  layout: {
    "ui:options": {
      placeholder: "Enter layout information...",
      height: "300px"
    }
  },
  materials_used: {
    "ui:options": {
      placeholder: "Enter materials used...",
      height: "300px"
    }
  },
  event: {
    "ui:widget": "textarea",
    "ui:emptyValue": ""
  }
};
